import { Suspense, lazy, useEffect } from 'react'
import { Route, Routes, useLocation } from 'react-router-dom'
import { Box, Flex, Spinner, Portal } from '@chakra-ui/react'

import Header from 'components/baseComponents/Header/Header'
import Footer from 'components/baseComponents/Header/Footer'
const HomePage = lazy(() => import('components/home/HomePage'))
const PlatformOverview = lazy(
  () => import('components/platformOverview/PlatformOverview')
)
const AboutUs = lazy(() => import('components/aboutUs/AboutUs'))
const NotFound = lazy(() => import('components/notFound/NotFound'))
const ContactUs = lazy(() => import('components/contact/ContactUs'))
const CaseStudiesPage = lazy(
  () => import('components/caseStudies/CaseStudiesPage')
)
const CaseStudyDetailPage = lazy(
  () => import('components/caseStudies/CaseStudyDetailPage')
)
const RiskManagement = lazy(
  () => import('components/riskManagement/RiskManagement')
)
const MultiCurrencyAccounts = lazy(
  () => import('components/multiCurrencyAccounts/MultiCurrencyAccounts')
)
const WhyWorldesk = lazy(() => import('components/whyWorldesk/WhyWorldesk'))
const LegalPage = lazy(() => import('components/legal/LegalPage'))

const LoadingScreen = () => {
  return (
    <Portal>
      <Flex
        position='fixed'
        inset='0'
        bg='whiteAlpha.900'
        zIndex='modal'
        align='center'
        justify='center'
      >
        <Spinner size='xl' color='blue.400' />
      </Flex>
    </Portal>
  )
}

const ScrollToTop = () => {
  const { pathname } = useLocation()

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' })
  }, [pathname])

  return null
}

function App() {
  return (
    <>
      <ScrollToTop />
      <Header />
      <Box
        as='main'
        p={{ base: '0px 20px', lg: '0 50px' }}
        my={{ base: '64px', xl: '109px' }}
        minH='calc(100vh - 300px)'
      >
        <Suspense fallback={<LoadingScreen />}>
          <Routes>
            <Route path='/' element={<HomePage />} />
            <Route path='/platform-overview' element={<PlatformOverview />} />
            <Route path='/risk-management' element={<RiskManagement />} />
            <Route
              path='/multi-currency-accounts'
              element={<MultiCurrencyAccounts />}
            />
            <Route path='/why-worldesk' element={<WhyWorldesk />} />
            <Route path='/about-us' element={<AboutUs />} />
            <Route path='/case-studies' element={<CaseStudiesPage />} />
            <Route
              path='/case-studies/:slug'
              element={<CaseStudyDetailPage />}
            />
            <Route path='/contact' element={<ContactUs />} />
            <Route path='/legal' element={<LegalPage slug='legal' />} />
            <Route
              path='/privacy-policy'
              element={<LegalPage slug='privacy-policy' />}
            />
            <Route
              path='/terms-of-service'
              element={<LegalPage slug='terms-of-service' />}
            />
            <Route path='*' element={<NotFound />} />
          </Routes>
        </Suspense>
      </Box>
      <Footer />
    </>
  )
}

export default App
